import request from '@/utils/requestVr'

// 查询商品分类信息列表分页
export function fetchList(query) {
    return request({
        url: '/vr/storage/enterprise/allocated/page',
        method: 'get',
        params: query,
    })
}

export function getObj(id) {
    return request({
        url: '/vr/storage/enterprise/allocated/detail?id=' + id,
        method: 'get',
    })
}
 

export function editObj(data) {
    return request({
        url: '/vr/storage/enterprise/allocated/edit',
        method: 'post',
        data: data,
    })
}
